import { Grid } from '@mui/material';
import { ODSText } from '@telekom-ods/react-ui-kit';
import { type FC } from 'react';

interface IntroHeaderProps {
  header: string;
  subHeader: string;
  theme: string;
}

const IntroHeader: FC<IntroHeaderProps> = ({ header, subHeader, theme }) => {
  const darkColor = theme === 'dark' ? '#f61488' : '';
  return (
    <Grid>
      <ODSText
        as='h1'
        className='intro-header'
        style={{
          margin: 0,
          color: darkColor,
        }}
      >
        {header}
      </ODSText>
      <ODSText
        className='p-text'
        style={{ color: darkColor }}
      >
        {subHeader}
      </ODSText>
    </Grid>
  );
};

export default IntroHeader;
